export const mappedKeyJSON = {
  Role: "profile_role_id",
  Gender: "gender_id",
  Fluency: "fluency_id",
  Title: "title_id",
  Suffix: "suffix_id",
  Language: "language_list_id",
  InternalJobTitle: "internal_job_title_id",
  TypeOfPartner: "profile_role_id",
  JobTitle: "job_title",
  JobRole: "job_role_list_id",
  Label: "label",
  PersonStatus: "person_status_id",
  CandidateStatusByGroup: "candidate_statuses",
  Overview: "overview",
  Country: "country_list_id",
  County: "country_list_id",
  CountyOnly: "county",
  City: "city",
  Currencies: "currency",
  WorkloadDistribution: "workload_distribution_id",
  ComplementaryService: "complementary_service_id",
  CoachTrainingHr: "coach_training_hr_id",
  CoachingHr: "coaching_hr_id",
  ReferencesNameAndContDetail: "references_name_and_cont_detail_id",
  IndustrySector: "industry_sector_list_id",
  PsychometricsUsed: "psychometrics_used",
  Discipline: "discipline_id",
  AtWhatLevel: "at_what_level_id",
  Level: "level_id",
  LawfulBia: "lawful_bia_id",
  Purpose: "purpose_id",
  ContactStatus: "contact_status_id",
  SectorExperience: "sector_experience_id", //"sector_experience_id",
  OrganisationPanels: "organisation_panels",
  CandidateStatus: "partner_candidate_statuses",
  DiagnosticTools: "diagnostic_tool_id",
  ClientType: "types_of_client_id",
  AssessmentClients: "assessment_clients",
  FirstName: "first_name",
  MiddleName: "middle_name",
  LastName: "last_name",
  FullName: "full_name",
  BusinessCity: "business_city",
  BusinessCountry: "business_country_list_id",
  BusinessCounty: "business_county",
  BusinessPostCode: "business_postcode",
  PostCode: "postcode",
  BusinessZipCode: "business_zipcode",
  CoachingAreasOfExpertise: "coaching_areas_of_expertise_id",
  CoachingSpecificAreasOfExpertise: "client_specific_areas_of_expertise",
  ClientLevelsAvailiable: "client_levels_availiable",
  client_levels_available_for: "client_levels_available_for",
  BioParagraph: "bio_paragraph",
  FacilitationAreasOfExpertise: "facilitation_areas_of_expertise_id",
  facilitatorAoe: "facilitator_aoe_id",
  FacilitationClients: "facilitation_clients",
  TypeOfAssessment: "type_of_assessment_id",
  TypesOfAssessment: "types_of_assessment_id",
  MostSeniorRoleHeld: "most_senior_role_held",
  WorkedInPublicSector: "worked_in_public_sector",
  WorkedInPrivateSector: "worked_in_private_sector",
  ThumbnailBio: "thumbnail_bio",
  RepresentativeClients: "representative_clients",
  RepresentatitiveClients: "representatitive_clients",
  LocationRadius: "location_radius",
  AvailableToTakeNewAssignments: "available_to_take_new_assignments",
  CurrentlyAvailableForAssignment: "currently_available_for_assignment",
  ExpertiseArea: "expertise_area_id",
  CliExpertise: "cli_expertise_id",
  LevelsCoachAt: "levels_coach_at",
  CpdHrs: "cpd_hrs_undertaken_by_calendar_year",
  LastJobTitle: "last_job_title",
  DepartmentList: "department_list_id",
  AssignmentsAndDevelopmentToDate:
    "assignments_and_development_to_date_participated",
  CurrentCapacity: "current_capacity",
  OverallNumberOfCoachingAssignments: "overall_number_of_coaching_assignments",
  CurrentNumberOfAssignments: "current_number_of_assignments",
  ProfessionalAffiliation: "professional_affiliation_id",
  CreatedAt: "created_at",
  Source: "source_id",
  Feedback: "feedback",
  EmployeeStatus: "employee_status_id",
  Zipcode: "zipcode",
  InternalNotes: "internal_notes",
  NumberOfAssignment: "number_of_assignment_id",
  MentoringAreasOfExpertise: "mentoring_areas_of_expertise_id",
  TravelExpenses: "travel_expenses_id",
  DeliveryMethod: "delivery_method_id",
  Rank: "rank_id",
  facilitationDayRate: "facilitation_day_rate_id",
  AssessmentHourRate: "assessment_hour_rate_id",
  // CoachingHourRate: "coaching_hour_rate_id",
  CoachingHourRate: "coaching_hr_id",
  SourceReferral1: "source_referral1",
  SourceReferral1Id: "source_referral1_id",
  SourceReferral3Id: "source_referral3_id",
  MentoringDayRate: "mentoring_day_rate_id",
  CoachingProgrammeRate: "coaching_programme_rate_id",
  Organisation: "organisation_id",
  CoachingHourlyRateRange:"coaching_hourly_rate_range",
};